export default "__VITE_ASSET__6658ce3b__"